import { createAction } from '@reduxjs/toolkit'
import {
  type DownloadMeterDataCsvBetweenSpecificDatesPayload,
  type DownloadMeterDataCsvFromStartDatePayload,
  type UpdateCompanyAlarmPayload
} from './companies-types'

/* Action Creators */

export const DownloadMeterDataCsvFromStartDateAction =
    createAction<DownloadMeterDataCsvFromStartDatePayload>('company/meterdata/downloadCsvStartingFromDate')

export const DownloadMeterDataCsvBetweenSpecificDatesAction =
    createAction<DownloadMeterDataCsvBetweenSpecificDatesPayload>('company(meterdata/downloadCsvBetweenDates')

export const UpdateCompanyAlarmAction =
    createAction<UpdateCompanyAlarmPayload>('company/alarms/updateAlarm')
